import Paragraph from 'antd/es/typography/Paragraph';
import DownloadIcon from 'assets/icons/download.svg';

export const TabComponent = (props: any) => {
    return (
        <div
            className="tabs-element button-style glowd-on-hover"
            style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
        >
            <div className="content">
                <Paragraph
                    className="title"
                    ellipsis={{ rows: 2, expandable: false }}
                    title={props.title}
                >
                    {props.title}
                </Paragraph>
                <span>
                    <img src={DownloadIcon} />
                </span>
            </div>
        </div>
    );
};
